<template>
  <div class="payment-provider-notice" :class="variantClass" role="status">
    <feather-icon :icon="icon" svgClasses="h-5 w-5" class="payment-provider-notice__icon" />
    <p class="payment-provider-notice__text">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'PaymentProviderNotice',
  props: {
    variant: {
      type: String,
      default: 'info',
      validator: value => ['info', 'redirect'].indexOf(value) !== -1
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    variantClass() {
      return `payment-provider-notice--${this.variant}`;
    },
    icon() {
      return this.variant === 'redirect' ? 'ExternalLinkIcon' : 'InfoIcon';
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-provider-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.85rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  line-height: 1.45;

  &__icon {
    flex-shrink: 0;
    margin-top: 0.1rem;
  }

  &__text {
    margin: 0;
  }

  &--info {
    background: rgba(92, 52, 152, 0.08);
    border: 1px solid rgba(92, 52, 152, 0.18);
    color: #4a4258;
  }

  &--redirect {
    background: rgba(255, 195, 6, 0.12);
    border: 1px solid rgba(255, 195, 6, 0.35);
    color: #5c4a12;
  }
}
</style>
